import React, { useRef, useState, useEffect } from 'react';
import { Container, Grid } from '@material-ui/core';
import Link from 'gatsby-plugin-transition-link/AniLink';
import { func, bool } from 'prop-types';
import Lottie from 'react-lottie';
import Image from '../Image';
import styles from './header.module.scss';
import logo from '../../assets/icons/logo-outlined-min.webp';
import logoPng from '../../assets/icons/logo-outlined-min.png';
import anim1 from '../../assets/animations/hamburger-open.json';
import anim2 from '../../assets/animations/hamburger-close.json';

const options1 = {
  loop: false,
  autoplay: false,
  animationData: anim1,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};
const options2 = {
  loop: false,
  autoplay: false,
  animationData: anim2,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const Header = ({
  toggleMenu,
  menuHidden,
}) => {
  const [isFirstAnim, setIsFirstAnim] = useState(true);
  const [isAnim1Stopped, setisAnim1Stopped] = useState(true);
  const [isAnim2Stopped, setisAnim2Stopped] = useState(true);
  const anim1Ref = useRef(null);
  const anim2Ref = useRef(null);
  const [firstRender, setFirstRender] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  const onComplete = () => {
    if (isFirstAnim) {
      setisAnim1Stopped(true);
    } else {
      setisAnim2Stopped(true);
    }
    setIsFirstAnim(!isFirstAnim);
  };

  const resize = () => {
    if (window !== 'undefined') {
      setIsMobile(window.innerWidth < 499);
    }
  };

  useEffect(() => {
    if (window) {
      window.addEventListener('resize', resize);
      setIsMobile(window.innerWidth < 499);
    }
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  useEffect(() => {
    if (!firstRender) {
      if (isFirstAnim) {
        setisAnim1Stopped(false);
        anim1Ref.current.play();
      } else {
        setisAnim2Stopped(false);
        anim2Ref.current.play();
      }
    } else {
      setFirstRender(!firstRender);
    }
  }, [menuHidden]);

  return (
    <Container
      component="header"
      className={[
        styles.container,
        !menuHidden ? styles.containerMenuShow : null,
      ].join(' ')}
    >
      <Grid
        container
        justify="space-between"
        alignItems="center"
        className={[
          styles.containerInner,
          !menuHidden ? styles.containerInnerThin : null,
        ].join(' ')}
      >
        <Grid item>
          {
            menuHidden ? (
              <Link fade to="/">
                <Image
                  source={{ main: logo, fall: logoPng }}
                  className={[
                    styles.logo,
                    !menuHidden && styles.hideLogo,
                  ].join(' ')}
                  alt="we app logo"
                />
              </Link>
            ) : (
              <img
                src={logo}
                className={[
                  styles.logo,
                  !menuHidden && styles.hideLogo,
                ].join(' ')}
                alt="we app logo"
              />
            )
          }
        </Grid>
        <Grid item className={!menuHidden ? styles.containerMenu : null}>
          <button
            onClick={toggleMenu}
            type="button"
            className={styles.buttonSideMenu}
          >
            {
              isFirstAnim ? (
                <Lottie
                  ref={anim1Ref}
                  isStopped={isAnim1Stopped}
                  options={options1}
                  height={isMobile ? 30 : 40}
                  width={isMobile ? 62 : 92}
                  eventListeners={[
                    {
                      eventName: 'complete',
                      callback: onComplete,
                    },
                  ]}
                />
              ) : (
                <Lottie
                  ref={anim2Ref}
                  isStopped={isAnim2Stopped}
                  options={options2}
                  height={isMobile ? 62 : 92}
                  width={isMobile ? 62 : 92}
                  eventListeners={[
                    {
                      eventName: 'complete',
                      callback: onComplete,
                    },
                  ]}
                />
              )
            }
          </button>
        </Grid>
      </Grid>
    </Container>
  );
};

Header.propTypes = {
  toggleMenu: func.isRequired,
  menuHidden: bool.isRequired,
};

export default Header;
